/* eslint-disable react/prop-types */
import { forwardRef, useEffect, useState, useMemo, useContext } from 'react';
import ReactTooltip from 'react-tooltip';
import shallow from 'zustand/shallow';
import { MathJax } from 'better-react-mathjax';

import useCanRefresh from './useCanRefresh';
import ExamPopup from './ExamPopup';

import { safeJoinURL } from 'libs/url';
import Typography from 'components/Typography';
import useBaseURL from 'hooks/useBaseURL';
import clsx from 'libs/clsx';
import Button from 'components/Button';
import AppContext from 'context/app.context';
import { openModalImage } from 'actions/app.action';
// import Input from 'components/Input';

function ExamQuestionDragPopup(
  {
    currentQuestionIndex,
    question,
    questionTotal,
    onRefresh,
    answer,
    onAnswerChange,
    // answerComponent, // Tidak memerlukan answer component, karena sudah di handle di component pertanyaan
    examNavigation,
  },
  ref
) {
  const path = useBaseURL();
  const [, dispatchApp] = useContext(AppContext);

  const [isRefreshLoading, setIsRefreshLoading] = useState(false);

  // @todo optimasi component yang terender. Terlalu banyak merender.
  const refresh = useCanRefresh((state) => state, shallow);
  const refreshStatus = useCanRefresh(
    (state) => ({
      status: state.list[currentQuestionIndex]?.status,
      willEnabledOn: state.list[currentQuestionIndex]?.willEnabledOn,
      enableBackByTimeout: () =>
        state.enableBackByTimeout(currentQuestionIndex),
    }),
    shallow
  );

  const handleHighlightImage = (url) => dispatchApp(openModalImage(url));

  useEffect(() => {
    if (refresh.list.length === 0 || refresh.list.length !== questionTotal) {
      refresh.initList(questionTotal);
    }
  }, [questionTotal, refresh, refresh.list.length]);

  // Apakah pertanyaan memiliki karakter [img],
  const questionContainImg = /\[img\]/i.test(question.question);

  const isGBRContainMp3 = /\.(?:wav|mp3)$/i.test(question.image);

  // Mengubah mathML asli menjadi span.
  const htmlTtbMathML = useMemo(
    () =>
      question.additionalQuestion.replace(/@url\//g, `${path.questionImage}s/`),
    [path.questionImage, question.additionalQuestion]
  );

  // Replace [@url] dengan questionImage path.
  // let tempQuestionString = question.question.replace(
  //   /@url\//g,
  //   `${path.questionImage}p/`
  // );

  // Replace [@url] dengan questionImage path.
  // const additionalQuestionString = question.additionalQuestion.replace(
  //   /@url\//g,
  //   `${path.questionImage}s/`
  // );
  // const AnswerContainerKu = ExamFill;

  // const AnswerContainerKu = () => (
  //   <ExamFill
  //     ref={ref}
  //     question={question}
  //     answer={answer}
  //     onAnswerChange={onAnswerChange}
  //     resetAnswer={resetAnswer}
  //   />
  // );

  // const componentInput = <AnswerContainer ref={ref} question={question} answer={answer} onAnswerChange={onAnswerChange} resetAnswer={resetAnswer} />

  // Replace [@url] dengan questionImage path.
  // tempQuestionString = tempQuestionString.replace(
  //   /<@isian>/i,
  //   // ReactDOMServer.renderToString(<Input label="" />)
  //   ''
  // );

  // const questionString = tempQuestionString;
  // tempQuestionString = tempQuestionString.replace(/<([^>]+)>/i, '');
  // const partQuestions = tempQuestionString.split(/<@isian>/i);
  // //kalimat1 <isian> kalimat2
  // //[kalimat1, kalimat2]

  // const questionArabic = /[\u0600-\u06FF]/.test(question.question);
  // const questionTtbArabic = /[\u0600-\u06FF]/.test(question.additionalQuestion);

  // Refresh soal.
  const handleRefreshClick = () => {
    if (!refreshStatus.status) return;

    setIsRefreshLoading(true);
    onRefresh({ done: () => setIsRefreshLoading(false) });

    refreshStatus.enableBackByTimeout();
  };

  // const items = partQuestions;
  // const itemList = [];
  // const juis = (tempQuestionString.match(/<@isian>/gi) || []).length;
  // // const itemDonk = [];
  // let i = 1;
  // let countjuis = 0;
  // items.forEach((item) => {
  //   itemList[i] = (
  //     <span
  //       dir="auto"
  //       className={clsx(questionArabic && 'xl:text-3xl text-2xl')}
  //       style={{
  //         fontFamily: questionArabic ? 'Traditional Arabic' : 'inherit',
  //       }}
  //       // eslint-disable-next-line react/no-danger
  //       dangerouslySetInnerHTML={{
  //         __html: `${item}`,
  //       }}
  //     />
  //   );
  //   i += 1;
  //   if (countjuis < juis) {
  //     itemList[i] = `@input|${countjuis}`;
  //     countjuis += 1;
  //   }
  //   i += 1;
  // });
  return (
    <>
      <div className="flex-0">{examNavigation}</div>

      {/* Heading */}
      <div className="flex flex-0 items-center justify-start gap-5 pt-10 mb-3">
        <Typography variant="subtitle1" className="font-medium">
          Pertanyaan
        </Typography>

        <div>
          <Button
            type="button"
            onClick={handleRefreshClick}
            size="sm"
            color="secondary"
            data-tip={
              refreshStatus.status
                ? 'Refresh data soal'
                : `Anda dapat mencoba lagi dalam ${refreshStatus.willEnabledOn} detik`
            }
            loading={isRefreshLoading}
            disabled={isRefreshLoading}
          >
            Refresh&nbsp;
            {!refreshStatus.status && <>({refreshStatus.willEnabledOn})</>}
          </Button>

          <ReactTooltip />
        </div>
      </div>

      {/* Paragraf tambahan */}
      {/* {additionalQuestionString && (
        <Typography
          as="div"
          className="font-readable select-none mt-5"
          gutterBottom
        >
          <div
            dir="auto"
            className={clsx(questionArabic && 'xl:text-3xl text-2xl')}
            style={{
              fontFamily: questionArabic ? 'Traditional Arabic' : 'inherit',
            }}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: additionalQuestionString,
            }}
          />
        </Typography>
      )} */}

      <div
        className={clsx(
          'grid shrink-0 overflow-hidden',
          question.additionalQuestion ? 'grid-cols-2 gap-10' : 'grid-cols-1'
        )}
      >
        {/* Paragraf tambahan */}
        {question.additionalQuestion && htmlTtbMathML && (
          <div className="overflow-y-auto h-full">
            <Typography
              as="div"
              className={clsx('font-readable select-none mt-5')}
              gutterBottom
            >
              <MathJax>
                {/* eslint-disable-next-line react/no-danger */}
                <span dangerouslySetInnerHTML={{ __html: htmlTtbMathML }} />
              </MathJax>
            </Typography>
          </div>
        )}

        <div className="overflow-y-auto h-full">
          {/* Pertanyaan */}
          <Typography
            as="div"
            className="font-readable select-none mt-5"
            gutterBottom
          >
            <ExamPopup
              ref={ref}
              question={question}
              answer={answer}
              onAnswerChange={onAnswerChange}
            />
          </Typography>

          {/* Petunjuk */}
          {question.instruction && (
            <Typography
              as="div"
              className="font-readable bg-gray-300 py-6 px-4 rounded-md shadow-md select-none mt-5"
              gutterBottom
            >
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: question.instruction,
                }}
              />
            </Typography>
          )}

          {/* Gambar tambahan */}
          {question.image && !questionContainImg && !isGBRContainMp3 && (
            <div className="mt-5">
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */}
              <img
                className="w-auto max-w-full block cursor-pointer"
                src={safeJoinURL(path.questionImage, question.image)}
                alt={question.image}
                onClick={() =>
                  handleHighlightImage(
                    safeJoinURL(path.questionImage, question.image)
                  )
                }
              />
            </div>
          )}

          {/* Mp3 tambahan */}
          {question.image && !questionContainImg && isGBRContainMp3 && (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <audio
              src={safeJoinURL(path.questionImage, question.image)}
              controls
              preload="auto"
              controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
              className="mx-auto"
            />
          )}
        </div>
      </div>
    </>
  );
}

ExamQuestionDragPopup = forwardRef(ExamQuestionDragPopup);

export default ExamQuestionDragPopup;
